export default __webpack_public_path__ + "static/media/svgFront.5eed65ae.svg";